import script from "./RowHead.vue?vue&type=script&setup=true&lang=ts"
export * from "./RowHead.vue?vue&type=script&setup=true&lang=ts"

import "./RowHead.vue?vue&type=style&index=0&id=06877c25&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06877c25"]])

export default __exports__